<div *ngIf="pipeline$ | async as pipeline" class="p-mb-5">
  <p-blockUI [target]="blockable" [blocked]="pipeline.loading" [autoZIndex]="false">
    <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
  </p-blockUI>
  <app-blockable #blockable>
    <app-sankey *ngIf="!pipeline.isEmpty"
        [data]="pipeline.chartData"
        [height]="pipeline.chartHeight"
        [options]="pipeline.chartOptions"
        (canvasClicked)="handlePipelineClick($event?.value)"
        ></app-sankey>
    <app-dashboard-empty-state *ngIf="pipeline.isEmpty" text="No leads came in during the selected period with the selected currency"></app-dashboard-empty-state>
  </app-blockable>
</div>
